import { render, staticRenderFns } from "./ScreenDispatchOrder.vue?vue&type=template&id=9efc462a&scoped=true&"
import script from "./ScreenDispatchOrder.vue?vue&type=script&lang=js&"
export * from "./ScreenDispatchOrder.vue?vue&type=script&lang=js&"
import style0 from "./ScreenDispatchOrder.vue?vue&type=style&index=0&id=9efc462a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efc462a",
  null
  
)

export default component.exports